import { render, staticRenderFns } from "./RoomPlanInfomation.vue?vue&type=template&id=35c3c776&scoped=true"
import script from "./RoomPlanInfomation.vue?vue&type=script&lang=js"
export * from "./RoomPlanInfomation.vue?vue&type=script&lang=js"
import style0 from "./RoomPlanInfomation.vue?vue&type=style&index=0&id=35c3c776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3c776",
  null
  
)

export default component.exports